export enum EMPLOYEE_PRESENCE {
  PRESENT = "PRESENT",
  ABSENT = "ABSENT",
}

// left for future use, for new avatar variants
export interface PresenceInformation {
  from: string | null;
  to: string | null;
  status: EMPLOYEE_PRESENCE;
  reason: string | null;
}
